import React from "react";
import classNames from "classnames";

import styles from "./SingleReport.module.scss";

export default props => {
  const {
    className,
    style,
    bgClass,
    label,
    value,
    icon: Icon,
    formatter,
    ...rest
  } = props;
  return (
    <div
      className={classNames(styles.item, className, bgClass, 'p-3 rounded')}
      style={style}
      {...rest}
    >
      <h6>{label}</h6>
      {Icon && <Icon className={styles.icon} />}
      <h4 className="m-0 text-nowrap" dir="ltr">
        {formatter ? formatter(value) : value}
      </h4>    
    </div>
  )
}